import { render, staticRenderFns } from "./VisualiserFrame.vue?vue&type=template&id=5c8fdd13&scoped=true&"
import script from "./VisualiserFrame.vue?vue&type=script&lang=js&"
export * from "./VisualiserFrame.vue?vue&type=script&lang=js&"
import style0 from "./VisualiserFrame.vue?vue&type=style&index=0&id=5c8fdd13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8fdd13",
  null
  
)

export default component.exports